<app-stages [stages]="stages" currentStage="Zdarzenie"></app-stages>
<br>
@if (!pending() && !loading()) {
  <form autocomplete="off" novalidate [formGroup]="form" (ngSubmit)='submitAndGoNext()'>
    <div class="row">
      <div class='col-md-12'>
        <div class='form-group' *ngIf='"description" as controlName'>
          <label [for]='controlName'>
            Przyczyna zdarzenia *
          </label>
          <textarea
            rows="8"
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu przyczynę zdarzenia'>
          </textarea>
          <app-validation-errors [showTextLength]="true" [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
    </div>
    <div class="row">
      <div class='col-md-6'>
        <div class='form-group' *ngIf='"city" as controlName'>
          <label [for]='controlName'>
            Miejscowość
          </label>
          <input
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu miejscowość'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
    </div>
    <app-exposed-map-control #expMapControl [alertMessage]="null" [control]="form.geometry"></app-exposed-map-control>
    <app-road-controls-set [expMapDict]="expMapControl.dictEvent()" [form]="form" [hideStreetControl]="true">
    </app-road-controls-set>
    <br>
    <div class="row">
      <div class="col-md-3">
        <div class='form-group' *ngIf='"eventStartDate" as controlName'>
          <label [for]='controlName'>
            Data zdarzenia *
          </label>
          <app-date-picker [id]='controlName' [formControlName]='controlName'>
          </app-date-picker>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-3'>
        <div class='form-group' *ngIf='"eventStartTime" as controlName'>
          <label [for]='controlName'>
            Czas zdarzenia *
          </label>
          <input
            mask="Hh:m0"
            [dropSpecialCharacters]="false"
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='00:00'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class="col-md-3">
        <div class='form-group' *ngIf='"estimatedDamageValue" as controlName'>
          <label [for]='controlName'>
            Szacowana wartość szkód *
          </label>
          <input
            mask="separator.2"
            decimalMarker=","
            [dropSpecialCharacters]="false"
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu szacowaną wartość'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
    </div>
    <div class="row">
      <div class='col-md-12'>
        <div class='form-group' *ngIf='"eventLocation" as controlName'>
          <label [for]='controlName'>
            Miejsce zdarzenia *
            <br>
            <small>(proszę uwzględnić w opisie miejsca m.in. warunki pogodowe, jakie towarzyszyły zdarzeniu oraz
              informację czy wnioskujący jest właścicielem czy współwłaścicielem pojazdu/mienia)</small>
          </label>
          <textarea
            rows="8"
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu miejsce zdarzenia'>
          </textarea>
          <app-validation-errors [maxTextLength]="255" [showTextLength]="true" [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-12'>
        <div class='form-group' *ngIf='"eventDescription" as controlName'>
          <label [for]='controlName'>
            Opis uszkodzeń *
          </label>
          <textarea
            rows="8"
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Opisz tu uszkodzenia'>
          </textarea>
          <app-validation-errors [showTextLength]="false" [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
    </div>
    <fieldset>
      <legend>
        Dane poszkodowanego
      </legend>
      <div class="row">
        <div class="col-md-8">
          <div class="form-group">
            <div class="custom-radio">
              <input (change)="form.injuredDataSameAsApplicantChange(false)" name="injuredDataSameAsApplicant"
                     formControlName="injuredDataSameAsApplicant" type="radio"
                     id="injuredDataNotSameAsApplicant" [value]="false">
              <label for="injuredDataNotSameAsApplicant">Chcę wprowadzić adresowe dane poszkodowanego</label>
            </div>
            <div class="custom-radio">
              <input (change)="form.injuredDataSameAsApplicantChange(true)" name="injuredDataSameAsApplicant"
                     formControlName="injuredDataSameAsApplicant" type="radio"
                     id="injuredDataSameAsApplicant" [value]="true">
              <label for="injuredDataSameAsApplicant">Adresowe dane poszkodowanego są takie same jak dane
                wnioskodawcy</label>
            </div>
          </div>
        </div>
      </div>
      <app-injured-person-form [form]="form.injuredPersonForm"></app-injured-person-form>
      <div class="row">
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"damageType" as controlName'>
            <label [for]='controlName'>
              Rodzaj szkody *
            </label>
            <select
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'>
              <option value=''>Wybierz</option>
              <option value='Osobowe'>Osobowe</option>
              <option value="Rzeczowe">
                Rzeczowe
              </option>
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
      <div class="row">
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"servicesNotifiedAboutEvent" as controlName'>
            <label [for]='controlName'>
              Służby powiadomione o zdarzeniu *
            </label>
            <select
              (change)="form.servicesNotifiedAboutEventChange(form.getElement($event).value)"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'>
              <option value=''>Wybierz</option>
              <option value='Policja'>Policja</option>
              <option value="Straż Pożarna">Straż Pożarna</option>
              <option value='Straż Miejska'>Straż Miejska</option>
              <option value='Inne służby'>Inne służby</option>
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        @if (form.servicesNotifiedAboutEventDesc) {
          <div class='col-md-8'>
            <div class='form-group' *ngIf='"servicesNotifiedAboutEventDesc" as controlName'>
              <label [for]='controlName'>
                Dane innych służb *
              </label>
              <input
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu dane innych służb'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        }
      </div>
    </fieldset>
    <fieldset>
      <legend>Informacje końcowe</legend>
      <div class="row">
        <div class='col-md-12'>
          <div class='form-group' *ngIf='"additionalInformation" as controlName'>
            <label [for]='controlName'>
              Informacje dodatkowe
            </label>
            <textarea
              rows="8"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu informacje dodatkowe'>
            </textarea>
            <app-validation-errors [showTextLength]="false" [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    </fieldset>
    <div class='application-actions'>
      <button
        type='button'
        class='btn btn-secondary'
        (click)='onCancel()'>
      <span>
        Wstecz
      </span>
      </button>
      <button
        type='button'
        class='btn btn-primary'
        (click)='submitAndGoNext()'>
        <span>Zapisz i przejdź dalej</span>
      </button>
    </div>
  </form>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
